import { render, staticRenderFns } from "./Product-Tab-Detail.vue?vue&type=template&id=004c0dec&scoped=true"
import script from "./Product-Tab-Detail.vue?vue&type=script&lang=js"
export * from "./Product-Tab-Detail.vue?vue&type=script&lang=js"
import style0 from "./Product-Tab-Detail.vue?vue&type=style&index=0&id=004c0dec&prod&scoped=true&lang=scss"
import style1 from "./Product-Tab-Detail.vue?vue&type=style&index=1&id=004c0dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c0dec",
  null
  
)

export default component.exports